export default __webpack_public_path__ + "images/064b8ce8ad6123cad0d39e6e22762545.svg";